import React, { FC, useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from 'src/config/firebase';
import { MediaLinksFilesView } from './components/MediaLinksFilesView/MediaLinksFilesView';
import { ChatMessage } from './types';

export const DashboardMediaLinksFilesScreen: FC = () => {
  const { chatId } = useParams<{ chatId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const inquiryId = searchParams.get('inquiryId') || undefined;
  const tabParam = searchParams.get('tab') as 'media' | 'files' | 'links' | null;
  const initialTab = tabParam === 'files' || tabParam === 'links' ? tabParam : 'media';

  const [realtimeMessages, setRealtimeMessages] = useState<ChatMessage[]>([]);

  // Listen to realtime messages for newly incoming attachments
  useEffect(() => {
    if (!chatId) return;

    const msgsRef = collection(db, 'flutter_chat_messages', chatId, 'messages');
    const q = query(msgsRef, orderBy('send_time', 'desc'), limit(50));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const msgs: ChatMessage[] = [];
        snapshot.forEach((doc) => {
          msgs.push({
            id: doc.id,
            ...(doc.data() as Omit<ChatMessage, 'id'>),
          });
        });
        setRealtimeMessages(msgs);
      },
      (error) => {
        console.error('Error listening to chat messages:', error);
      },
    );

    return () => unsubscribe();
  }, [chatId]);

  const handleBack = () => {
    if (chatId) {
      const returnUrl = inquiryId
        ? `/onboarding-trainer/dashboard/messages/${chatId}?inquiryId=${inquiryId}`
        : `/onboarding-trainer/dashboard/messages/${chatId}`;
      navigate(returnUrl);
    } else {
      navigate('/onboarding-trainer/dashboard/messages');
    }
  };

  if (!chatId) {
    return null;
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        background: '#060723',
      }}
    >
      <MediaLinksFilesView
        chatId={chatId}
        inquiryId={inquiryId}
        messages={realtimeMessages}
        initialTab={initialTab}
        onBack={handleBack}
      />
    </div>
  );
};
